module.exports = __webpack_public_path__ + "img/img0307.84daaf97.png";